import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "../statics/styles/borders-scss.js";
const CellBorders = ({ borders }) => [
  /* @__PURE__ */ React.createElement(
    "div",
    {
      key: "top",
      style: borders?.top && { background: borders.top },
      className: classNames(styles.borderT, borders?.top && styles.borderColorOverride)
    }
  ),
  /* @__PURE__ */ React.createElement(
    "div",
    {
      key: "bottom",
      style: borders?.bottom && { background: borders.bottom },
      className: classNames(styles.borderB, borders?.bottom && styles.borderColorOverride)
    }
  ),
  /* @__PURE__ */ React.createElement(
    "div",
    {
      key: "right",
      style: borders?.right && { background: borders.right },
      className: classNames(styles.borderR, borders?.right && styles.borderColorOverride)
    }
  ),
  /* @__PURE__ */ React.createElement(
    "div",
    {
      key: "left",
      style: borders?.left && { background: borders.left },
      className: classNames(styles.borderL, borders?.left && styles.borderColorOverride)
    }
  )
];
CellBorders.propTypes = {
  borders: PropTypes.object
};
var CellBorders_default = CellBorders;
export {
  CellBorders_default as default
};
//# sourceMappingURL=CellBorders.js.map
